// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-assistant .ant-drawer {
  border-radius: none;
}
.ai-assistant .ant-drawer-close {
  position: fixed;
  right: 30px;
  font-size: large;
  color: #d2042d;
}
.chatbot-icon {
  cursor: pointer;
  position: fixed;
  bottom: 140px;
  right: 26px;
  z-index: 100;
  background: #fff;
  padding: 43px 26px;
  border-radius: 50%;
  height: 80px;
  display: flex;
  align-items: center;
  border-radius: 100px;
  background: #fff;
  box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.16);
  cursor: pointer;
}
.ai-header {
  font-family: Montserrat;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  margin: 24px auto 22px 2vw;
}
.sparkles-icon {
  position: relative;
  bottom: 1.35vw;
  left: 5px;
}
.ai {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: var(--Font-Font-Size-h5, 23px);
  font-style: normal;
  font-weight: 700;
}
.chatbot.ant-drawer.ant-drawer-content {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
}
.ai-assistant .ant-drawer-header,
.ai-assistant .ant-drawer-body {
  padding: 0;
}

.ai-divider {
  margin: 0;
  border-color: #cdcdcd;
  border-width: 2px;
}
.ai-chat-content {
  display: block;
  height: 75vh;
  overflow-y: scroll;
}
.ai-guide-content {
  display: flex;
  margin: 18px 30px 33px 30px;
}
.reverse-direction {
  flex-direction: row-reverse;
}
.sparkles-chat-icon {
  display: flex;
  width: 40px;
  height: 40px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 250px;
  background: #fff;
  box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.15);
}
.user-icon {
  display: flex;
}
.rfp-exit-text {
  margin-top: 0.3rem;
}
.ai-response-link {
  color: #d2042d;
  text-decoration: underline;
}
.greeting-text {
  font-family: Roboto;
  font-size: 1vw;
  font-style: normal;
  font-weight: 400;
  margin-left: 13px;
}
.add-background {
  background: var(--Colors-Primary-500, #d2042d);
  padding: 0.5rem 1rem;
  border-radius: 10px 10px 0 10px;
  color: #fff;
  margin-right: 0.5rem;
}
.total-greeting-text {
  color: #000;
  display: flex;
  align-items: center;
  line-height: 1.75rem;
}
.ai-text {
  color: var(--Colors-Primary-500, #d2042d);
}
.sendIcon {
  cursor: pointer;
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d);
  padding: 10px;
}
.disable-send {
  cursor: not-allowed;
  opacity: 0.5;
}
.chat-input {
  font-family: Roboto;
  width: 100%;
}
.chat-input:hover {
  border-color: #0a0f0d !important;
}
.chat-input.ant-input-outlined:focus-within {
  border-color: #0a0f0d !important;
}
.input-section {
  position: fixed;
  bottom: 0vh;
  width: -webkit-fill-available;
}
.input-section .ant-input-outlined:focus {
  border-radius: 5px;
  border: 1px solid var(--Colors-Text-100, #b3b5b4);
  background: #fff;
}

.chatbot.ant-drawer-right > .ant-drawer-content-wrapper {
  width: 32vw !important;
}
.rfp-suggestions {
  display: flex;
  gap: 1rem;
}
.user-help {
  font-family: Roboto;
  display: flex;
  padding: 0.5rem 1rem;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  border-radius: 5px;
  background: #ffdbe3;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 1vw;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
  width: fit-content;
}
.suggested-questions{
  margin-left: 18%;
}
.quit-text {
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  font-size: 1rem;
  position: absolute;
  bottom: 6rem;
}
.set-height {
  height: 65vh;
}
.d-none {
  display: none;
}
.typing-indicator {
  font-style: italic;
  color: #888;
  position: relative;
  display: inline-block;
}

.typing-indicator::after {
  content: "";
  display: inline-block;
  width: 2rem;
  text-align: left;
  animation: dots 1.2s steps(3, end) infinite;
}

.chatbot-navigation-a {
  color: #d2042d;
  -webkit-text-decoration: "underline";
          text-decoration: "underline";
}

.chatbot-select-location-css {
  font-family: Roboto;
  width: 25vw;
  border: 1px solid #f5f5f5;
}

.chatbot-select-location-spinner {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 4rem;
  margin-bottom: 1rem;
}
.chatbot.ant-drawer .ant-drawer-content {
  border-top-left-radius: 0% !important;
  border-top-right-radius: 0% !important;
}
@keyframes dots {
  0% {
    content: "";
  }
  33% {
    content: ".";
  }
  66% {
    content: "..";
  }
  100% {
    content: "...";
  }
}
.no-cursor {
  cursor: not-allowed;
  background: gray;
  color: rgb(212, 210, 210);
}
@media (min-width: 767px) and (max-width: 1024px) {
  .ai-header {
    padding-top: 1rem;
  }
  .ai-divider {
    margin-top: 1.8rem;
  }
  .chatbot .ant-drawer-right > .ant-drawer-content-wrapper {
    width: 58vw !important;
  }
  .greeting-text,
  .user-help {
    font-size: 2vw;
  }
  .suggested-questions{
    margin-left: 13%;
  }
}
@media (max-width: 768px) {
  .chatbot .ant-drawer-content-wrapper {
    width: 100vw !important;
  }

  .greeting-text,
  .user-help {
    font-size: 3vw;
  }
  .suggested-questions{
  margin-left: 11%;
   }
}

@media (max-width: 430px) {
  .chatbot-icon {
    bottom: 31vw !important;
    right: 2vw;
    padding: 12px;
    height: 62px !important;
    height: 80px;
  }
  .total-greeting-text {
    line-height: 1.2rem;
  }
  .ai-guide-content{
    margin-bottom: 10px;
  }
  .suggested-questions{
  margin-left: 19%;
   }
}
@media (max-width: 391px) {
  .chatbot-icon {
    bottom: 20vw !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/chatbot-drawer/chatBotSlideIn.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;AACA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;AACA;;EAEE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,+BAA+B;EAC/B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,cAAc;EAChB;EACA;EACA,gBAAgB;GACf;AACH;;AAEA;EACE;IACE,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;EACA,gBAAgB;GACf;AACH;AACA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".ai-assistant .ant-drawer {\n  border-radius: none;\n}\n.ai-assistant .ant-drawer-close {\n  position: fixed;\n  right: 30px;\n  font-size: large;\n  color: #d2042d;\n}\n.chatbot-icon {\n  cursor: pointer;\n  position: fixed;\n  bottom: 140px;\n  right: 26px;\n  z-index: 100;\n  background: #fff;\n  padding: 43px 26px;\n  border-radius: 50%;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  border-radius: 100px;\n  background: #fff;\n  box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.16);\n  cursor: pointer;\n}\n.ai-header {\n  font-family: Montserrat;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 23px;\n  font-style: normal;\n  font-weight: 700;\n  margin: 24px auto 22px 2vw;\n}\n.sparkles-icon {\n  position: relative;\n  bottom: 1.35vw;\n  left: 5px;\n}\n.ai {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: var(--Font-Font-Size-h5, 23px);\n  font-style: normal;\n  font-weight: 700;\n}\n.chatbot.ant-drawer.ant-drawer-content {\n  border-top-left-radius: 0px !important;\n  border-top-right-radius: 0px !important;\n}\n.ai-assistant .ant-drawer-header,\n.ai-assistant .ant-drawer-body {\n  padding: 0;\n}\n\n.ai-divider {\n  margin: 0;\n  border-color: #cdcdcd;\n  border-width: 2px;\n}\n.ai-chat-content {\n  display: block;\n  height: 75vh;\n  overflow-y: scroll;\n}\n.ai-guide-content {\n  display: flex;\n  margin: 18px 30px 33px 30px;\n}\n.reverse-direction {\n  flex-direction: row-reverse;\n}\n.sparkles-chat-icon {\n  display: flex;\n  width: 40px;\n  height: 40px;\n  padding: 10px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 250px;\n  background: #fff;\n  box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.15);\n}\n.user-icon {\n  display: flex;\n}\n.rfp-exit-text {\n  margin-top: 0.3rem;\n}\n.ai-response-link {\n  color: #d2042d;\n  text-decoration: underline;\n}\n.greeting-text {\n  font-family: Roboto;\n  font-size: 1vw;\n  font-style: normal;\n  font-weight: 400;\n  margin-left: 13px;\n}\n.add-background {\n  background: var(--Colors-Primary-500, #d2042d);\n  padding: 0.5rem 1rem;\n  border-radius: 10px 10px 0 10px;\n  color: #fff;\n  margin-right: 0.5rem;\n}\n.total-greeting-text {\n  color: #000;\n  display: flex;\n  align-items: center;\n  line-height: 1.75rem;\n}\n.ai-text {\n  color: var(--Colors-Primary-500, #d2042d);\n}\n.sendIcon {\n  cursor: pointer;\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d);\n  padding: 10px;\n}\n.disable-send {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.chat-input {\n  font-family: Roboto;\n  width: 100%;\n}\n.chat-input:hover {\n  border-color: #0a0f0d !important;\n}\n.chat-input.ant-input-outlined:focus-within {\n  border-color: #0a0f0d !important;\n}\n.input-section {\n  position: fixed;\n  bottom: 0vh;\n  width: -webkit-fill-available;\n}\n.input-section .ant-input-outlined:focus {\n  border-radius: 5px;\n  border: 1px solid var(--Colors-Text-100, #b3b5b4);\n  background: #fff;\n}\n\n.chatbot.ant-drawer-right > .ant-drawer-content-wrapper {\n  width: 32vw !important;\n}\n.rfp-suggestions {\n  display: flex;\n  gap: 1rem;\n}\n.user-help {\n  font-family: Roboto;\n  display: flex;\n  padding: 0.5rem 1rem;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  margin-top: 0.5rem;\n  border-radius: 5px;\n  background: #ffdbe3;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 1vw;\n  font-style: normal;\n  font-weight: 400;\n  cursor: pointer;\n  width: fit-content;\n}\n.suggested-questions{\n  margin-left: 18%;\n}\n.quit-text {\n  display: flex;\n  justify-content: flex-start;\n  gap: 1rem;\n  font-size: 1rem;\n  position: absolute;\n  bottom: 6rem;\n}\n.set-height {\n  height: 65vh;\n}\n.d-none {\n  display: none;\n}\n.typing-indicator {\n  font-style: italic;\n  color: #888;\n  position: relative;\n  display: inline-block;\n}\n\n.typing-indicator::after {\n  content: \"\";\n  display: inline-block;\n  width: 2rem;\n  text-align: left;\n  animation: dots 1.2s steps(3, end) infinite;\n}\n\n.chatbot-navigation-a {\n  color: #d2042d;\n  text-decoration: \"underline\";\n}\n\n.chatbot-select-location-css {\n  font-family: Roboto;\n  width: 25vw;\n  border: 1px solid #f5f5f5;\n}\n\n.chatbot-select-location-spinner {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-right: 4rem;\n  margin-bottom: 1rem;\n}\n.chatbot.ant-drawer .ant-drawer-content {\n  border-top-left-radius: 0% !important;\n  border-top-right-radius: 0% !important;\n}\n@keyframes dots {\n  0% {\n    content: \"\";\n  }\n  33% {\n    content: \".\";\n  }\n  66% {\n    content: \"..\";\n  }\n  100% {\n    content: \"...\";\n  }\n}\n.no-cursor {\n  cursor: not-allowed;\n  background: gray;\n  color: rgb(212, 210, 210);\n}\n@media (min-width: 767px) and (max-width: 1024px) {\n  .ai-header {\n    padding-top: 1rem;\n  }\n  .ai-divider {\n    margin-top: 1.8rem;\n  }\n  .chatbot .ant-drawer-right > .ant-drawer-content-wrapper {\n    width: 58vw !important;\n  }\n  .greeting-text,\n  .user-help {\n    font-size: 2vw;\n  }\n  .suggested-questions{\n    margin-left: 13%;\n  }\n}\n@media (max-width: 768px) {\n  .chatbot .ant-drawer-content-wrapper {\n    width: 100vw !important;\n  }\n\n  .greeting-text,\n  .user-help {\n    font-size: 3vw;\n  }\n  .suggested-questions{\n  margin-left: 11%;\n   }\n}\n\n@media (max-width: 430px) {\n  .chatbot-icon {\n    bottom: 31vw !important;\n    right: 2vw;\n    padding: 12px;\n    height: 62px !important;\n    height: 80px;\n  }\n  .total-greeting-text {\n    line-height: 1.2rem;\n  }\n  .ai-guide-content{\n    margin-bottom: 10px;\n  }\n  .suggested-questions{\n  margin-left: 19%;\n   }\n}\n@media (max-width: 391px) {\n  .chatbot-icon {\n    bottom: 20vw !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
